import { getLanguageName } from 'util/llmTranslation';
import { IconTranslationOutlined } from 'components/common/SVGIcons';
import { Root, TranslationTooltip } from './TranslationInfo.styles';

export default function TranslationInfo({ from, to }) {
  const fromLanguageName = getLanguageName(from);
  const toLanguageName = getLanguageName(to);
  const content = `This message has been translated\nfrom ${fromLanguageName} to ${toLanguageName}`;

  return (
    <Root>
      <TranslationTooltip arrow placement="top" content={content}>
        <IconTranslationOutlined width={12} height={12} role="img" aria-label="Translation Info" />
      </TranslationTooltip>
    </Root>
  );
}
